import {Mapper} from '@s-ui/domain'

export class BreadcrumbListStructuredDataSeoMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.structuredDataValueObjectFactory
   * */
  constructor({config, structuredDataValueObjectFactory}) {
    super()
    this._config = config
    this._structuredDataValueObjectFactory = structuredDataValueObjectFactory
  }

  /**
   * https://schema.org/BreadcrumbList
   * @param {Object} params
   * @param {Array} params.breadcrumb - Array of breadcrumb items
   * @param {String} params.id - Optional ID for the breadcrumb list (for @graph references)
   * @return {StructuredDataValueObject}
   */
  map = ({breadcrumb, id}) => {
    const itemList = breadcrumb.map(({label: name, url: id}, index) => {
      const hasUrl = Boolean(id)
      const position = index + 1
      return hasUrl
        ? {
            '@type': 'ListItem',
            position,
            item: {
              '@type': 'Thing',
              id,
              name
            }
          }
        : null
    })

    const breadcrumbListSchema = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      ...(id && {'@id': id}),
      itemListElement: itemList.filter(Boolean)
    }

    return this._structuredDataValueObjectFactory(breadcrumbListSchema)
  }
}
